import React from 'react';
import { useAlert } from '../context/AlertContext';

const Alert = () => {
  const { alert, hideAlert } = useAlert();

  if (!alert) {
    return null;
  }

  const { message, variant } = alert;

  const alertConfig = {
    success: {
      bgColor: 'bg-green-500',
      icon: '✓',
    },
    danger: {
      bgColor: 'bg-red-500',
      icon: '!',
    },
  };

  const { bgColor, icon } = alertConfig[variant] || alertConfig.danger;

  return (
    <div className={`fixed top-28 right-5 p-4 rounded-lg text-white ${bgColor} max-w-xs shadow-lg z-[5000]`} role="alert">
      <div className="flex items-center ">
        <span className="font-bold text-2xl pt-2 mr-2">{icon}</span>
        <p className="pt-2 text-wrap">{message}</p>
        <button onClick={hideAlert} className="absolute top-2 right-2 text-white text-2xl leading-none">
          &times;
        </button>
      </div>
    </div>
  );
};

export default Alert;
